module.exports = __webpack_public_path__ + "img/list_google_slides.6c8f252b.png";